<template>
  <div style="" :class="classListMenu()">
    <div class="container__aichat_menu_close_button">
      <button @click="setShow" class="container__aichat_box_header_button">
        <v-icon>mdi-list-box</v-icon>
        <span>بستن منو</span>
      </button>
      <button @click="setMenus" class="container__aichat_box_header_button">
        <v-icon>mdi-forum-plus</v-icon>
        <span>چت جدید</span>
      </button>
    </div>

    <div style="padding: 0 10px; overflow-y: auto">
      <List />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import List from "./modules/list.vue";
export default {
  name: "MenuAi",
  props: {
    menu: Boolean,
  },
  components: { List },

  methods: {
    ...mapActions("chatAi", ["setShow"]),
    ...mapActions("chatAi", ["setNewChat"]),

    classListMenu() {
      return this.ShowMenuAi
        ? "container__aichat_menu"
        : "container__aichat_menu_hidden";
    },
    setMenus() {
      this.setShow();
      this.setNewChat();
    },
  },

  computed: {
    ...mapState("chatAi", ["ShowMenuAi"]),
  },
};
</script>

<style scoped>
.container__aichat_menu {
  left: 0;
  width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: 70vh;
  border-radius: 12px;
  display: flex;
  transition: all linear 1s;
  flex-direction: column;
}
.container__aichat_menu_hidden {
  width: 0 !important;
  transition: all linear 1s;
  display: none;
}
.container__aichat_menu_close_button {
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: space-between;
  padding-inline: 1rem;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  background: white;
  gap: 15px;
}

.container__aichat_menu_title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 10px;
}

@media screen and (max-width: 640px) {
  .container__aichat_menu {
    position: absolute;
    width: 240px;
    background: white;
  }
}
</style>
